export default __webpack_public_path__ + "static/star-logo-2-978f5904d51f2f95c1aa0b61a5124b4e.png";